import React from 'react';
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import TabThree from '../elements/tab/TabThree';
import BenefitEmployee from "../elements/service/BenefitEmployee";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const OneStopShop = () => {
    const { t } = useTranslation('enterprise');
    const StopShopData = [
        {
            image: "/images/bg/bg-home-1.png",
            title: t('lePlan.title'),
            description: t('lePlan.subtitle'),
        },
    ]
    return (
        <>
            <SEO title="N01ZET One-stop shop platform - Innonvation Blockchain Saas - Blockchain DeFi - employee retention - rétention employée  " />
            <main className="page-wrapper main-mobile-responsive">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="1" >
                    {StopShopData.map((data) => (
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inner text-left">
                                    <h1 className="title display-one cust-title mt-5" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                    <p className="description" style={{ fontSize: '20px' }} dangerouslySetInnerHTML={{__html: data.description}}></p>
                                    {/* <div className="button-group">
                                        <Link className="btn-default btn-medium btn-icon" to="#">One-stop shop<i className="icon"><FiArrowRight /></i></Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" src="/images/bg/one-stopshop.png" alt='stop-shop' />
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                {/* End Slider Area  */}

                {/* Start One-stop shop Area  */}
                <div className="rwt-tab-area rn-section-gap">
                    <div className="container">
                        <TabThree />
                    </div>
                </div>
                {/* End One-stop shop Area  */}

                {/* Start Essential Area  */}
                <div className="rwt-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = {t('lePlan.essentiel.title')}
                                    description = {t('lePlan.essentiel.subtitle')}
                                />
                            </div>
                        </div>
                        <div className="about-area about-style-4">
                            <div className="container">
                                <div className="row row--40 align-items-center">
                                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                                        <div className="content">
                                            <div className="inner">
                                                <ul className="feature-list">
                                                    <li> 
                                                        <div className="icon">
                                                            <FiCheck />
                                                        </div>
                                                        <h3 className="title" style={{marginTop:'-10px',marginBottom:'0px',marginLeft:'10px'}}>{t('lePlan.essentiel.entreprisesConcernes.title')}</h3>
                                                    </li>
                                                    <li>
                                                    {t('lePlan.essentiel.entreprisesConcernes.content')}
                                                    </li>
                                                    <li className="pt-5"> 
                                                        <div className="icon">
                                                            <FiCheck />
                                                        </div>
                                                        <h3 className="title" style={{marginTop:'-10px',marginBottom:'0px',marginLeft:'10px'}}>{t('lePlan.essentiel.salariesConcernes.title')}</h3>
                                                    </li>
                                                    <li>
                                                    {t('lePlan.essentiel.salariesConcernes.content')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 text-center">
                                            <div className="video-btn">
                                                <img src='/images/split/company-concerned.png' alt='essentials' width={"400px"}/>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center pt-5 mt-5'>
                                <Link className="btn-default btn-medium btn-icon" to="/contact">{t('buttons.beContacted')}<i className="icon"><FiArrowRight /></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Essential Area  */}
                <Separator />
                {/* Start Companies  */}

                <div className="about-area about-style-4 rn-section-gap">
                    <div className="container">
                        <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                            <div className="col-lg-6 text-center">
                                    <div className="video-btn">
                                        <img src='/images/split/stopshop-companies.png' alt="for-companies" width={"300px"}/>
                                    </div>
                            </div>
                            <div className="col-lg-6 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title"> {t("lePlan.essentiel.pourLentreprise.title")}</h3>
                                        <ul className="feature-list">
                                        {t("lePlan.essentiel.pourLentreprise.content", {
                                            returnObjects: true,
                                            }).map((e, i) => {
                                            return <li key={i}>
                                                <div className='icon'>
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{marginTop:"0px",marginBottom:"0px"}}>{e}</p>
                                                </div>
                                            </li>;
                                        })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* End Companies  */}
                <Separator />
                {/* Start Employees   */}

                <div className="about-area about-style-4 rn-section-gap">
                    <div className="container">
                        <div className="row align-items-center pl-5 pt-5 pb-5 lt-display">
                            <div className="col-lg-6 mt_md--40 mt_sm--40">
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title">{t("lePlan.essentiel.pourLeSalarie.title")}</h3>
                                        <ul className="feature-list">
                                        {t("lePlan.essentiel.pourLeSalarie.content", {
                                            returnObjects: true,
                                            }).map((e, i) => {
                                            return <li key={i}>
                                                <div className='icon'>
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{marginTop:"0px",marginBottom:"0px"}}>{e}</p>
                                                </div>
                                            </li>;
                                        })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 text-center">
                                    <div className="video-btn">
                                        <img src='/images/split/stopshop-employees.png' alt="for-employees" width={"400px"} style={{borderRadius:'20px'}}/>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>  
                {/* Start Employees  */}
                <Separator />
                {/* Start Benefit Employees Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('avantages.lesAvantagesSalaries.title')}
                                    description={t('avantages.lesAvantagesSalaries.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitEmployee
                            serviceStyle="service__style--1 radius mt--20 rbt-border responsive-tabs"
                            textAlign="text-left"
                        />
                        <div className='text-center pt-5 mt-5'>
                        <Link className="btn-default btn-medium btn-icon" to="/benefits">{t('buttons.learnMore')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>

                    </div>
                </div>
                {/* End Benefit Employees Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default OneStopShop